import {Product} from "./product";

export class OrderItem {
    id: string;
    referenceId: string;
    referenceObject: string;
    product: Product;
    name: string;
    priceGross: number;
    priceGrossBeforeDiscount?: number = 0;
    priceNet: number;
    quantity: number;
    unit: string;
    vatRate: number;
}
